/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var getGraphqlData = (function (body, _ref) {
  var name = _ref.name,
    schema = _ref.schema;
  // If data was returned
  if (body.data) {
    // If the DataHook config has an array of schemas then don't try to pull anything out of the data
    if (Array.isArray(schema)) {
      return body.data;
    }

    // if the DataHook config has a single query as a schema then use the query name to get it's response
    return body.data[name];
  }

  // if there's no data on the body then most likely there was an error. Return false.
  return false;
});

export { getGraphqlData as default };
